export const YesNoEnum = [
    { id: 'yes', name: 'Yes' },
    { id: 'no', name: 'No' }
];